function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { forwardRef, Fragment, useEffect, useImperativeHandle, useRef, useState } from 'react';
import AriaModal from 'react-aria-modal';
import Container from './container';
import Header from './header';
import Body from './body';
import Footer from './footer';
import noop from '../../utils/noop';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fixedAppearance = {
  desktop: 'floating',
  tablet: 'floating',
  mobile: 'fullscreen'
};
var fitContentAppearance = {
  desktop: 'floating',
  tablet: 'floating',
  mobile: 'auto'
};
var Modal = /*#__PURE__*/forwardRef((_ref, ref) => {
  var _ref$onShow = _ref.onShow,
    onShow = _ref$onShow === void 0 ? noop : _ref$onShow,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? noop : _ref$onClose,
    _ref$onMount = _ref.onMount,
    onMount = _ref$onMount === void 0 ? noop : _ref$onMount,
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? false : _ref$show,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    children = _ref.children,
    footer = _ref.footer,
    showHeader = _ref.showHeader,
    _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? [] : _ref$actions,
    _ref$appearance = _ref.appearance,
    appearanceProp = _ref$appearance === void 0 ? {} : _ref$appearance,
    mobileStyle = _ref.mobileStyle,
    closeButton = _ref.closeButton,
    _ref$enableScroll = _ref.enableScroll,
    enableScroll = _ref$enableScroll === void 0 ? true : _ref$enableScroll,
    _ref$hackBodyOverlay = _ref.hackBodyOverlay,
    hackBodyOverlay = _ref$hackBodyOverlay === void 0 ? false : _ref$hackBodyOverlay,
    width = _ref.width,
    height = _ref.height,
    maxWidth = _ref.maxWidth,
    maxHeight = _ref.maxHeight,
    minWidth = _ref.minWidth,
    minHeight = _ref.minHeight,
    fitContent = _ref.fitContent,
    allowOverflow = _ref.allowOverflow;
  var modalBodyRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showContents = _useState2[0],
    setShowContents = _useState2[1];
  var isMounted = useRef(false);
  var defaultAppearance = fitContent ? fitContentAppearance : fixedAppearance;
  var appearance = {
    mobile: mobileStyle || appearanceProp.mobile || defaultAppearance.mobile,
    tablet: appearanceProp.tablet || defaultAppearance.tablet,
    desktop: appearanceProp.desktop || defaultAppearance.tablet
  };
  var resetScroll = () => {
    if (modalBodyRef.current) {
      modalBodyRef.current.scrollTop = 0;
    }
  };
  useImperativeHandle(ref, () => ({
    resetScroll
  }), []);
  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      onMount();
    }
  }, [onMount]);
  var handleShow = () => {
    setShowContents(true);
  };
  var handleClose = () => {
    setShowContents(false);
  };
  var handleContentShow = () => {
    onShow();
  };
  var handleContentHide = () => {
    onClose();
  };
  return ___EmotionJSX(Fragment, null, show && ___EmotionJSX(AriaModal, {
    titleText: "modal",
    onEnter: handleShow,
    onExit: handleClose,
    focusDialog: true
  }, ___EmotionJSX(Container, {
    showModal: showContents,
    appearance: appearance,
    onShow: handleContentShow,
    onHide: handleContentHide,
    width: width,
    height: height,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    minWidth: minWidth,
    minHeight: minHeight,
    fitContent: fitContent,
    allowOverflow: allowOverflow
  }, ___EmotionJSX(Header, {
    actions: actions,
    handleClose: handleClose,
    showHeader: showHeader,
    heading: title,
    appearance: appearance,
    closeButton: closeButton
  }), ___EmotionJSX(Body, {
    ref: modalBodyRef,
    enableScroll: enableScroll,
    hackOverlay: hackBodyOverlay,
    fitContent: fitContent,
    allowOverflow: allowOverflow
  }, children), footer && ___EmotionJSX(Footer, null, footer))));
});
export default Modal;